export default __webpack_public_path__ + "static/media/payjak-logotype-l.98df1377.svg";